export const createAction = <T extends string>(type: T) =>
  function <P>() {
    const fn = (payload: P) => ({ type, payload });
    fn.getType = () => type;
    return fn;
  };
